module.exports = __webpack_public_path__ + "static/media/2@3x.6ac7e470.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/2@3x.png
// module id = 755
// module chunks = 0